import {customElement, property} from 'lit/decorators.js';
import {html, css, LitElement} from 'lit';

@customElement('language-switcher')
export class LanguageSwitcher extends LitElement {
  @property({type: String}) lang: string;

  static readonly styles = [
    css`
      .language-switcher {
        display: flex;
        flex-direction: row;
        background: white;
        height: 50px;
        align-items: flex-end; /* Aligns buttons to the bottom */
      }
      .language-btn {
        border: none;
        background: none;
        color: var(--line-grey);
        font-weight: 400;
        font-size: 18px;
        padding: 3px 8px;
        font-family: 'Arial', sans-serif;
        border-right: 1px solid var(--line-grey);
        cursor: pointer;
      }
      .language-btn-last {
        border-right: none;
      }
      .active {
        font-weight: 700;
      }
    `,
  ];

  private setLanguage(newLang: string) {
    if (this.lang !== newLang) {
      this.dispatchEvent(
        new CustomEvent('language-change', {
          detail: {lang: newLang},
        }),
      );
    }
  }

  render() {
    return html`
      <div class="language-switcher">
        <button
          part="button"
          class="btn language-btn ${this.lang === 'de' ? ' active' : ''}"
          @click=${() => this.setLanguage('de')}
        >
          D
        </button>
        <button
          part="button"
          class="btn language-btn ${this.lang === 'it' ? ' active' : ''}"
          @click=${() => this.setLanguage('it')}
        >
          I
        </button>
        <button
          part="button"
          class="btn language-btn language-btn-last ${this.lang === 'rm' ? ' active' : ''}"
          @click=${() => this.setLanguage('rm')}
        >
          R
        </button>
      </div>
    `;
  }
}
